/**
 * /app/trusts/$id/beneficiaries — Beneficiary register (route shell).
 *
 * Screen impl in `./index-screen.tsx`, lazy-loaded via `lazyRouteComponent`. A
 * deep trust sub-tab (beneficiary table + contact edit + notify + statement
 * download), not a first-paint route, so the body leaves the entry bundle
 * (200 kB gzip budget). Same shell+screen pattern as the sibling `../audit.tsx`
 * / `../documents.tsx` tabs. The committed routeTree.gen.ts imports only `Route`
 * from here, so no plugin regen is needed.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/app/trusts/$id/beneficiaries/')({
  component: lazyRouteComponent(() => import('./index-screen'), 'BeneficiariesScreen'),
});
